/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { onMounted, ref } from 'vue'

const useAppear = () => {
  const target = ref<HTMLDivElement>()
  const coverVisible = ref(false)
  onMounted(() => {
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        coverVisible.value = true
        observer.unobserve(target.value!) // 停止观察
      }
    })

    observer.observe(target.value!) // 观察当前组件的根元
  })

  return {
    target,
    coverVisible
  }
}

export default useAppear
